import styled from 'styled-components'

export const Trash = styled.div`
    .ory-controls-trash {
        position: fixed;
        bottom: -64px;
        z-index: 500;
        left: calc(50% - 200px);
        transition: bottom 200ms ease;

        button {
            -webkit-appearance: none;
            -webkit-backface-visibility: hidden;
            text-align: center;
            height: 60px;
            width: 60px;
            color: #ffffff;
            font-size: 24px;
            border-radius: 50%;
            background-color: ${props => props.theme.admin.colors.danger};
            box-shadow: 0 0 5px 1px ${props => props.theme.admin.colors.danger};
            border: none;
            transition: all 200ms ease;
            -webkit-transform: translateZ(0);
            transform: scale(1) translateZ(0);

            &:disabled {
                transform: scale(0.8);
                box-shadow: 0 0 3px 1px ${props => props.theme.admin.colors.danger};
            }
        }
    }

    .ory-controls-trash.ory-controls-trash-active {
        bottom: 16px;
    }
`
